import React, { useState } from "react";

/* Legacy Admin Panel — replaces the old AdminDesk inside the Secure Vault.
   Founder Core Bypass keys off the current user's email/handle. */
export const LegacyAdminPanel = ({ userEmail, userHandle }) => {
  // FOUNDER IDENTITY VALIDATION (BYPASS LOOKUPS INSTANTLY)
  const isFounder =
    userHandle?.toLowerCase() === "johnnywalker" ||
    userEmail?.toLowerCase() === "djohnm1972@gmail.com";

  const [vaultKey, setVaultKey] = useState("");
  const [activeTab, setActiveTab] = useState("MONITOR");

  // LOCKOUT STATE: PEACH COLOURED (#FFA6A6) UNINITIALIZED KEY DIALOG BOX
  if (!isFounder) {
    return (
      <div className="border-2 border-black bg-[#FFA6A6] p-4 my-2 shadow-[3px_3px_0px_#1A1A1A] max-w-[412px] w-full" data-testid="legacy-admin-locked">
        <div className="flex items-center justify-between mb-2">
          <span className="font-mono text-xs font-bold uppercase tracking-wider text-black">
            [SYS_LOCK_ERR]
          </span>
          <div className="w-2.5 h-2.5 bg-red-600 border border-black animate-pulse" />
        </div>
        <p className="font-mono text-xs uppercase font-bold text-black mb-1">
          UNINITIALIZED ENVELOPE DETECTED
        </p>
        <p className="font-mono text-[11px] text-black leading-tight">
          ACCESS DELEGATION REFUSED. PROVIDER ENVELOPE IS LOCKED BY LEDGER TRACE.
        </p>
      </div>
    );
  }

  // UNLOCKED STATE: DENSE 2-COLUMN COMMAND CENTRE DIRECTORY WORKSPACE
  return (
    <div className="border-2 border-black bg-white p-3 my-2 shadow-[3px_3px_0px_#1A1A1A] max-w-[412px] w-full" data-testid="legacy-admin-panel">
      {/* Top Header Panel Strip */}
      <div className="flex justify-between items-center border-b-2 border-black pb-2 mb-3">
        <div className="flex items-center gap-1.5">
          <div className="w-3 h-3 bg-[#38BDF8] border border-black" />
          <span className="font-mono text-xs font-bold uppercase tracking-tight text-black">
            FOUNDER_PANEL // v9.0
          </span>
        </div>
        <div className="flex border border-black text-[10px] font-mono">
          <button
            type="button"
            onClick={() => setActiveTab("MONITOR")}
            data-testid="legacy-admin-tab-mon"
            className={`px-2 py-0.5 border-r border-black font-bold uppercase ${activeTab === "MONITOR" ? "bg-black text-white" : "bg-gray-100 text-black"}`}
          >
            MON
          </button>
          <button
            type="button"
            onClick={() => setActiveTab("LOGS")}
            data-testid="legacy-admin-tab-log"
            className={`px-2 py-0.5 font-bold uppercase ${activeTab === "LOGS" ? "bg-black text-white" : "bg-gray-100 text-black"}`}
          >
            LOG
          </button>
        </div>
      </div>

      {activeTab === "MONITOR" ? (
        /* DENSE 2-COLUMN SPACE UTILIZATION MATRIX */
        <div className="grid grid-cols-2 gap-2 text-black font-mono">
          {/* Col 1: Database Partition and Envelope Vault Keys */}
          <div className="border border-black p-2 bg-gray-50 flex flex-col justify-between">
            <div>
              <span className="text-[10px] font-bold block uppercase text-gray-500 mb-1">
                DATA_CLUSTER
              </span>
              <span className="text-xs font-bold block truncate">
                misteck_preview
              </span>
              <span className="text-[9px] text-green-700 font-bold block mt-1">
                ● ACTIVE_PARTITION
              </span>
            </div>
            <div className="mt-3 pt-2 border-t border-dashed border-gray-400">
              <span className="text-[10px] font-bold block uppercase text-gray-500 mb-1">
                VAULT_ADMIN_KEY
              </span>
              <input
                type="password"
                value={vaultKey}
                onChange={(e) => setVaultKey(e.target.value)}
                placeholder="••••••••"
                data-testid="legacy-admin-vaultkey"
                className="w-full text-xs p-1 border border-black bg-white font-mono focus:outline-none"
              />
            </div>
          </div>

          {/* Col 2: Live Inbound API Pipelines & Whitelist Parameters */}
          <div className="border border-black p-2 bg-gray-50 flex flex-col justify-between">
            <div>
              <span className="text-[10px] font-bold block uppercase text-gray-500 mb-1">
                CORE_ROUTING
              </span>
              <div className="space-y-1 text-[10px]">
                <div className="flex justify-between">
                  <span>RESEND_EMAIL:</span>
                  <span className="text-green-600 font-bold">LIVE</span>
                </div>
                <div className="flex justify-between">
                  <span>TAX_INBOUND:</span>
                  <span className="text-green-600 font-bold">READY</span>
                </div>
                <div className="flex justify-between">
                  <span>SOLANA_RPC:</span>
                  <span className="text-blue-600 font-bold">READ</span>
                </div>
              </div>
            </div>
            <div className="mt-2 pt-2 border-t border-dashed border-gray-400 text-[9px] leading-tight text-gray-600">
              BYPASS ENFORCED FOR:
              <span className="font-bold text-black block truncate">{userHandle || "johnnywalker"}</span>
            </div>
          </div>
        </div>
      ) : (
        /* BACKEND PROCESS LOG STREAMING ACCENT */
        <div className="border border-black bg-black p-2 text-green-400 font-mono text-[10px] h-[106px] overflow-y-auto leading-tight space-y-0.5">
          <div>&gt; JIM_PROFILE_ACTIVE // LEDGER LOCK ENFORCED</div>
          <div>&gt; TAX_WEBHOOK.PY DETECTING PIPELINES...</div>
          <div>&gt; SYSTEM ENVIRONMENT RECONCILED SUCCESS</div>
          <div>&gt; VIEWPORT SCALE LOCKED STRICTLY TO 412PX</div>
          <div>&gt; SECURE VAULT COMPONENT ROUTE MOUNTED</div>
        </div>
      )}
    </div>
  );
};

export default LegacyAdminPanel;
